module.exports = __webpack_public_path__ + "img/IMG_3539_L_Foamcore_MockedUp.eecfc1e6.jpg";